module.exports = __webpack_public_path__ + "img/banner1.88198f2c.jpg";